import React, { useState, useEffect } from "react";
import { Global } from "@emotion/react";
import { styled } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { grey } from "@mui/material/colors";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { useAppContext } from "../../AppContext";
import axios from "axios";
import { MyDomain } from "../../App";
import { useParams } from "react-router-dom";
import * as signalR from "@microsoft/signalr";
import { useTranslation } from "react-i18next";

const drawerBleeding = 56;

const Root = styled("div")(({ theme }) => ({
  height: "100%",
  backgroundColor: grey[100],
}));

const StyledBox = styled("div")(({ theme }) => ({
  backgroundColor: "#fff",
  borderTopLeftRadius: "24px",
  borderTopRightRadius: "24px",
}));

const Puller = styled("div")(({ theme }) => ({
  width: 40,
  height: 5,
  backgroundColor: grey[300],
  borderRadius: 3,
  position: "absolute",
  top: 12,
  left: "calc(50% - 20px)",
}));

function MPHomeModalMakeApp(props) {
  const { t } = useTranslation();
  const { BarberPhoneNumber } = useParams();

  const {
    OpenDrawer,
    setOpenDrawer,
    ObjectData,
    setSelectedServices,
    SelectedServices,
    User,
    AllData,
    ChoosedApps,
    triggerRefresh,
    setValue,
    setStep,
    step,
    Lang,
  } = useAppContext();

  // RTL language detection
  const isRTL = Lang === "ar" || Lang === "he";

  console.log(AllData.barberData.expoToken);
  const { window } = props;
  const [IsLoading, setIsLoading] = useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpenDrawer(newOpen);
  };

  const container =
    window !== undefined ? () => window().document.body : undefined;

  const BookApp = async () => {
    if (!User || !User.name || !User.phoneNumber) {
      console.error("User data not available:", User);
      alert("Please login first to book an appointment.");
      setOpenDrawer(false);
      return;
    }

    setIsLoading(true);

    const totalDuration = SelectedServices.reduce(
      (sum, service) => sum + (service.Duration || 0),
      0
    );

    const findAdditionalAppointments = () => {
      const additionalAppIds = [];
      let accumulatedTime = ObjectData.timeLength;
      let currentIndex = -1;

      for (let i = 0; i < ChoosedApps.length; i++) {
        if (ChoosedApps[i].id === ObjectData.id) {
          currentIndex = i;
          break;
        }
      }

      if (currentIndex === -1 || accumulatedTime >= totalDuration) {
        return additionalAppIds;
      }

      let nextIndex = currentIndex + 1;
      while (
        nextIndex < ChoosedApps.length &&
        accumulatedTime < totalDuration
      ) {
        const nextApp = ChoosedApps[nextIndex];
        const prevApp = ChoosedApps[nextIndex - 1];

        if (prevApp.timeEnd !== nextApp.timeStart) {
          break;
        }

        if (nextApp.isTaken === 1) {
          break;
        }

        additionalAppIds.push(nextApp.id);
        accumulatedTime += nextApp.timeLength;
        nextIndex++;
      }

      return additionalAppIds;
    };

    const additionalAppIds = findAdditionalAppointments();

    console.log("📋 Main appointment ID:", ObjectData.id);
    console.log(
      "📋 Additional appointment IDs to mark as IsTaken=4:",
      additionalAppIds
    );

    const data2 = {
      Appointment: {
        Id: ObjectData.id,
        PhoneNumber: User.phoneNumber,
        Name: User.name,
        IsTaken: 1,
        Date: ObjectData.date,
        TimeStart: ObjectData.timeStart,
        TimeEnd: ObjectData.timeEnd,
        TimeLength: ObjectData.timeLength,
        BarberPhoneNumber: ObjectData.barberPhoneNumber,
      },
      Barber: {
        ExpoToken: AllData.barberData.expoToken,
      },
      Lang: Lang,
      BookedServices: SelectedServices,
      AllServices: SelectedServices,
      AdditionalAppointmentIds: additionalAppIds,
    };

    try {
      const response = await axios.put(
        `${MyDomain}Appointments2/UpdateAppWithServices`,
        data2,
        {
          timeout: 10000,
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("✅ Booking successful:", response.data);

      setValue(1);
      setStep(5);
      setSelectedServices([]);

      setTimeout(() => {
        setOpenDrawer(false);
      }, 100);
    } catch (error) {
      console.error("❌ Error booking appointment:", error);

      if (error.code === "ECONNABORTED") {
        alert("Request timeout. Please check your internet connection.");
      } else if (error.response) {
        alert(`Booking failed: someone already booked this app`);
      } else if (error.request) {
        alert("Network error. Please check your internet connection.");
      } else {
        alert("Failed to book appointment. Please try again.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const totalPrice = SelectedServices.reduce(
    (sum, service) => sum + parseFloat(service.Price || 0),
    0
  );

  useEffect(() => {
    if (!BarberPhoneNumber && !ObjectData?.barberPhoneNumber) {
      console.warn("⚠️ No barber phone number available");
      return;
    }

    const barberPhone = ObjectData?.barberPhoneNumber || BarberPhoneNumber;
    console.log("🔄 Setting up SignalR in Modal for barber:", barberPhone);

    const connection = new signalR.HubConnectionBuilder()
      .withUrl(`${MyDomain}appointmentHub`)
      .withAutomaticReconnect({
        nextRetryDelayInMilliseconds: (retryContext) => {
          if (retryContext.elapsedMilliseconds < 60000) {
            return Math.random() * 10000;
          }
          return null;
        },
      })
      .configureLogging(signalR.LogLevel.Information)
      .build();

    connection.onclose((error) => {
      console.log("🔌 Modal SignalR connection closed");
      if (error) console.log("Reason:", error.message);
    });

    connection.onreconnecting(() => {
      console.log("🔄 Modal SignalR reconnecting...");
    });

    connection.onreconnected((connectionId) => {
      console.log("✅ Modal SignalR reconnected! ID:", connectionId);
    });

    const startConnection = async () => {
      try {
        if (connection.state === signalR.HubConnectionState.Disconnected) {
          await connection.start();
          console.log("✅ Modal SignalR connected!");
          console.log("🔑 Connection ID:", connection.connectionId);

          connection.on("ReceiveBookingUpdate", (data) => {
            console.log("📩 ReceiveBookingUpdate in Modal:", data);
            setOpenDrawer(false);
          });

          connection.on("AppointmentCreated", (data) => {
            console.log("📩 AppointmentCreated in Modal:", data);
            setOpenDrawer(false);
          });
        }
      } catch (err) {
        console.error("❌ Modal SignalR connection error:", err);
        setTimeout(() => {
          if (connection.state === signalR.HubConnectionState.Disconnected) {
            startConnection();
          }
        }, 5000);
      }
    };

    startConnection();

    return () => {
      console.log("🧹 Cleaning up Modal SignalR...");

      if (connection) {
        connection.off("ReceiveBookingUpdate");
        connection.off("AppointmentCreated");

        const state = connection.state;
        if (
          state === signalR.HubConnectionState.Connected ||
          state === signalR.HubConnectionState.Connecting
        ) {
          connection
            .stop()
            .then(() => console.log("✅ Modal SignalR disconnected"))
            .catch((err) => {
              if (!err.message?.includes("connection being closed")) {
                console.log("⚠️ Error stopping Modal SignalR:", err.message);
              }
            });
        }
      }
    };
  }, [BarberPhoneNumber, ObjectData?.barberPhoneNumber, setOpenDrawer]);

  const barberName = AllData?.barberName || t("ProfessionalBarber");
  const barberAddress = AllData?.barberAddress || "";
  const barberPhone = AllData?.barberPhone || BarberPhoneNumber;

  useEffect(() => {
    console.log("=== MPHomeModalMakeApp User Data ===");
    console.log("User object:", User);
    console.log("User.Name:", User?.name);
    console.log("User.PhoneNumber:", User?.phoneNumber);
    console.log("User from localStorage:", localStorage.getItem("User"));
    console.log("===================================");
  }, [User]);

  return (
    <Root>
      <CssBaseline />
      <Global
        styles={{
          ".MuiDrawer-root > .MuiPaper-root": {
            height: "auto",
            maxHeight: "90%",
            overflow: "visible",
            borderTopLeftRadius: "24px",
            borderTopRightRadius: "24px",
          },
          "*": {
            WebkitTapHighlightColor: "transparent",
            WebkitTouchCallout: "none",
          },
          button: {
            WebkitTapHighlightColor: "transparent !important",
            outline: "none !important",
          },
        }}
      />
      <SwipeableDrawer
        container={container}
        anchor="bottom"
        open={OpenDrawer}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
        swipeAreaWidth={0}
        disableSwipeToOpen={true}
        disableBackdropTransition={false}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          zIndex: 1050,
        }}
      >
        <Puller />
        <StyledBox
          sx={{
            px: 3,
            pt: 4,
            pb: 3,
            maxHeight: "85vh",
            overflowY: "auto",
            direction: isRTL ? "rtl" : "ltr",
          }}
        >
          {/* Header */}
          <div style={{ marginBottom: "24px", textAlign: "center" }}>
            <div style={{ fontSize: "48px", marginBottom: "8px" }}>✂️</div>
            <h2
              style={{
                fontSize: "24px",
                fontWeight: "700",
                color: "#1a1a1a",
                margin: "0 0 8px 0",
              }}
            >
              {t("ConfirmYourBooking")}
            </h2>
            <p
              style={{
                fontSize: "14px",
                color: "#6b7280",
                margin: 0,
              }}
            >
              {t("ReviewAppointmentDetails")}
            </p>
          </div>

          {/* User Information */}
          <div
            style={{
              backgroundColor: "#f0f9ff",
              borderRadius: "16px",
              padding: "16px",
              marginBottom: "16px",
              border: "1px solid #bfdbfe",
            }}
          >
            <div
              style={{
                fontSize: "12px",
                color: "#1e40af",
                fontWeight: "600",
                marginBottom: "8px",
                letterSpacing: "0.5px",
                textAlign: isRTL ? "right" : "left",
              }}
            >
              👤 {t("YourInformation")}
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "6px",
                textAlign: isRTL ? "right" : "left",
              }}
            >
              <div
                style={{
                  fontSize: "16px",
                  fontWeight: "600",
                  color: "#1a1a1a",
                }}
              >
                {User?.name || t("Guest")}
              </div>
              <div
                style={{
                  fontSize: "14px",
                  color: "#374151",
                }}
              >
                📱 {User?.phoneNumber || t("NotAvailable")}
              </div>
            </div>
          </div>

          {/* Barber Information */}
          <div
            style={{
              backgroundColor: "#fef3c7",
              borderRadius: "16px",
              padding: "16px",
              marginBottom: "16px",
              border: "1px solid #fde68a",
            }}
          >
            <div
              style={{
                fontSize: "12px",
                color: "#92400e",
                fontWeight: "600",
                marginBottom: "8px",
                letterSpacing: "0.5px",
                textAlign: isRTL ? "right" : "left",
              }}
            >
              ✂️ {t("BarberDetails")}
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "6px",
                textAlign: isRTL ? "right" : "left",
              }}
            >
              <div
                style={{
                  fontSize: "16px",
                  fontWeight: "600",
                  color: "#1a1a1a",
                }}
              >
                {barberName}
              </div>
              {barberAddress && (
                <div
                  style={{
                    fontSize: "14px",
                    color: "#374151",
                  }}
                >
                  📍 {barberAddress}
                </div>
              )}
              <div
                style={{
                  fontSize: "14px",
                  color: "#374151",
                }}
              >
                📞 {barberPhone}
              </div>
            </div>
          </div>

          {/* Appointment Details */}
          <div
            style={{
              backgroundColor: "#f3f4f6",
              borderRadius: "16px",
              padding: "16px",
              marginBottom: "16px",
            }}
          >
            <div
              style={{
                fontSize: "12px",
                color: "#6b7280",
                fontWeight: "600",
                marginBottom: "12px",
                letterSpacing: "0.5px",
                textAlign: isRTL ? "right" : "left",
              }}
            >
              📅 {t("AppointmentDetails")}
            </div>

            <div
              style={{ display: "flex", flexDirection: "column", gap: "12px" }}
            >
              {/* Date */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  flexDirection: isRTL ? "row-reverse" : "row",
                }}
              >
                <div
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "10px",
                    backgroundColor: "#667eea",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "20px",
                    flexShrink: 0,
                  }}
                >
                  📆
                </div>
                <div
                  style={{
                    flex: 1,
                    textAlign: isRTL ? "right" : "left",
                  }}
                >
                  <div style={{ fontSize: "12px", color: "#6b7280" }}>
                    {t("Date")}
                  </div>
                  <div
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#1a1a1a",
                    }}
                  >
                    {ObjectData.date}
                  </div>
                </div>
              </div>

              {/* Time */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  flexDirection: isRTL ? "row-reverse" : "row",
                }}
              >
                <div
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "10px",
                    backgroundColor: "#667eea",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "20px",
                    flexShrink: 0,
                  }}
                >
                  🕐
                </div>
                <div
                  style={{
                    flex: 1,
                    textAlign: isRTL ? "right" : "left",
                  }}
                >
                  <div style={{ fontSize: "12px", color: "#6b7280" }}>
                    {t("Time")}
                  </div>
                  <div
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#1a1a1a",
                    }}
                  >
                    {ObjectData.timeStart} - {ObjectData.timeEnd}
                  </div>
                </div>
              </div>

              {/* Duration */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  flexDirection: isRTL ? "row-reverse" : "row",
                }}
              >
                <div
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "10px",
                    backgroundColor: "#667eea",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "20px",
                    flexShrink: 0,
                  }}
                >
                  ⏱️
                </div>
                <div
                  style={{
                    flex: 1,
                    textAlign: isRTL ? "right" : "left",
                  }}
                >
                  <div style={{ fontSize: "12px", color: "#6b7280" }}>
                    {t("Duration")}
                  </div>
                  <div
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#1a1a1a",
                    }}
                  >
                    {ObjectData.timeLength} {t("Minutes")}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Services Summary */}
          {SelectedServices.length > 0 && (
            <div
              style={{
                backgroundColor: "#f0fdf4",
                borderRadius: "16px",
                padding: "16px",
                marginBottom: "24px",
                border: "1px solid #bbf7d0",
              }}
            >
              <div
                style={{
                  fontSize: "12px",
                  color: "#065f46",
                  fontWeight: "600",
                  marginBottom: "12px",
                  letterSpacing: "0.5px",
                  textAlign: isRTL ? "right" : "left",
                }}
              >
                💼 {t("SelectedServicesUpper")}
              </div>
              {SelectedServices.map((service, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "10px 0",
                    borderBottom:
                      index < SelectedServices.length - 1
                        ? "1px solid #d1fae5"
                        : "none",
                    flexDirection: isRTL ? "row-reverse" : "row",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: isRTL ? "flex-end" : "flex-start",
                    }}
                  >
                    <span style={{ fontSize: "15px", color: "#1a1a1a" }}>
                      {service.Service}
                    </span>
                    {service.Duration && (
                      <span style={{ fontSize: "12px", color: "#6b7280" }}>
                        {service.Duration} {t("Min")}
                      </span>
                    )}
                  </div>
                  <span
                    style={{
                      fontWeight: "600",
                      fontSize: "15px",
                      color: "#059669",
                    }}
                  >
                    ₪{service.Price}
                  </span>
                </div>
              ))}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "12px",
                  paddingTop: "12px",
                  borderTop: "2px solid #10b981",
                  flexDirection: isRTL ? "row-reverse" : "row",
                }}
              >
                <span
                  style={{
                    fontSize: "16px",
                    fontWeight: "700",
                    color: "#1a1a1a",
                  }}
                >
                  {t("TotalPrice")}
                </span>
                <span
                  style={{
                    fontSize: "22px",
                    fontWeight: "700",
                    color: "#059669",
                  }}
                >
                  ₪{totalPrice.toFixed(2)}
                </span>
              </div>
            </div>
          )}

          {/* Action Buttons */}
          <div
            style={{
              display: "flex",
              gap: "12px",
              marginBottom: "16px",
              flexDirection: isRTL ? "row-reverse" : "row",
            }}
          >
            <button
              onClick={toggleDrawer(false)}
              disabled={IsLoading}
              style={{
                flex: 1,
                padding: "16px",
                fontSize: "16px",
                fontWeight: "600",
                border: "1px solid #e5e7eb",
                borderRadius: "12px",
                backgroundColor: "#fff",
                color: "#6b7280",
                cursor: IsLoading ? "not-allowed" : "pointer",
                transition: "opacity 0.2s ease, transform 0.1s ease",
                opacity: IsLoading ? 0.5 : 1,
                WebkitTapHighlightColor: "transparent",
                outline: "none",
                userSelect: "none",
              }}
              onTouchStart={(e) => {
                if (!IsLoading) {
                  e.currentTarget.style.opacity = "0.7";
                  e.currentTarget.style.transform = "scale(0.98)";
                }
              }}
              onTouchEnd={(e) => {
                if (!IsLoading) {
                  e.currentTarget.style.opacity = "1";
                  e.currentTarget.style.transform = "scale(1)";
                }
              }}
            >
              {t("Cancel")}
            </button>
            <button
              onClick={BookApp}
              disabled={IsLoading}
              style={{
                flex: 2,
                padding: "16px",
                fontSize: "16px",
                fontWeight: "600",
                border: "none",
                borderRadius: "12px",
                backgroundColor: IsLoading ? "#9ca3af" : "#10b981",
                color: "#fff",
                cursor: IsLoading ? "not-allowed" : "pointer",
                transition:
                  "opacity 0.2s ease, transform 0.1s ease, box-shadow 0.2s ease",
                boxShadow: IsLoading
                  ? "none"
                  : "0 4px 16px rgba(16, 185, 129, 0.4)",
                WebkitTapHighlightColor: "transparent",
                outline: "none",
                userSelect: "none",
              }}
              onTouchStart={(e) => {
                if (!IsLoading) {
                  e.currentTarget.style.opacity = "0.9";
                  e.currentTarget.style.transform = "scale(0.98)";
                }
              }}
              onTouchEnd={(e) => {
                if (!IsLoading) {
                  e.currentTarget.style.opacity = "1";
                  e.currentTarget.style.transform = "scale(1)";
                }
              }}
            >
              {IsLoading ? (
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                  }}
                >
                  <span
                    style={{
                      width: "16px",
                      height: "16px",
                      border: "2px solid #fff",
                      borderTopColor: "transparent",
                      borderRadius: "50%",
                      animation: "spin 0.8s linear infinite",
                    }}
                  />
                  {t("BookingInProgress")}
                </span>
              ) : (
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                  }}
                >
                  <span>✓</span>
                  {t("ConfirmBooking")}
                </span>
              )}
            </button>
          </div>

          {/* Info Note */}
          <div
            style={{
              padding: "12px 16px",
              backgroundColor: "#eff6ff",
              borderRadius: "12px",
              fontSize: "13px",
              color: "#1e40af",
              textAlign: "center",
              border: "1px solid #bfdbfe",
            }}
          >
            <div style={{ fontWeight: "600", marginBottom: "4px" }}>
              📱 {t("ConfirmationMessage")}
            </div>
            <div style={{ fontSize: "12px", color: "#3b82f6" }}>
              {t("WhatsAppConfirmation")}
            </div>
          </div>
        </StyledBox>
      </SwipeableDrawer>

      {/* Add keyframe animation for loading spinner */}
      <style>
        {`
          @keyframes spin {
            to {
              transform: rotate(360deg);
            }
          }
        `}
      </style>
    </Root>
  );
}

export default MPHomeModalMakeApp;
